import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import PropTypes from 'prop-types';
import ArchiveBlogPage from '@/components/blog/pages/ArchiveBlogPage';
import BlogLayout from '@/components/blog/pages/BlogLayout';
import { initializeStore } from '@/redux/initialize-store';
import { getBlogServerSideProps } from '@/utils/blogUtils';
import { sendFacebookEvent } from '@/utils/facebookServerUtils';

export const ArchiveSlug = ({ data, slug, storeConf }) => (
	<BlogLayout storeConf={storeConf} data={data} slug={slug} isArchivePage>
		<ArchiveBlogPage {...data} slug={slug} />
	</BlogLayout>
);

ArchiveSlug.propTypes = {
	data: PropTypes.object.isRequired,
	slug: PropTypes.string.isRequired,
	storeConf: PropTypes.object.isRequired,
};

export default ArchiveSlug;

export const getServerSideProps = async (ctx) => {
	const store = initializeStore({ ssrContext: ctx });
	return getBlogServerSideProps(ctx, store, serverSideTranslations, sendFacebookEvent, true);
};
